import myzxios from '../utils/myaxios'

export function getWxConfigList(data) {
    return myzxios({
        url: '/manager/wx/queryConfigList',
        params: data
    })
}

export function editConfig(data) {
    return myzxios({
        url: '/manager/wx/editConfig',
        data,
        method: 'post'
    })
}

export function uploadAuthTxt(data) {
    return myzxios({
        url: "/manager/wx/up-Au-txt",
        headers:{
            "Content-Type": "multipart/form-data"
        },
        data,
        method: 'post'
    })
}